import React, { useContext, useMemo } from "react";
import FlowContext from "../../../../contexts/flowContext";
import SidebarContext from "../../../../contexts/sidebar";
import styles from "./nodeList.module.css";

const NodeList = () => {
  const [flowState, flowDispatcher] = useContext(FlowContext);
  const [, sidebarDispatcher] = useContext(SidebarContext);

  const nodeList = useMemo(() => {
    return flowState.nodes.sort((a, b) =>
      a.data.name.normalize().localeCompare(b.data.name.normalize())
    );
  }, [flowState.nodes]);

  const handleNodeClick = function (node) {
    flowDispatcher({
      type: "set-selected-node",
      node,
    });
    flowDispatcher({
      type: "unselect-all-edges",
    });
    sidebarDispatcher({
      type: "set-manager",
      manager: "node",
    });
    flowState.rfInstance.fitBounds(
      { x: node.position.x, y: node.position.y, width: 100, height: 100 },
      { duration: 1000, zoomLevel: 1 }
    );
  };

  return (
    <div className={styles.node_list_container}>
      {nodeList.map((node, index) => (
        <div
          className={styles.node}
          key={index}
          onClick={() => handleNodeClick(node)}
        >
          {node.data.name}
        </div>
      ))}
      {!nodeList.length && (
        <div className={styles.no_node_message}>
          <p>Commencez par ajouter des noeuds</p>
        </div>
      )}
    </div>
  );
};

export default NodeList;
